<template>
    <b-container fluid>
        <b-row>
            <b-col xl="12" lg="12" sm="12">
                <iq-card>
                    <template v-slot:body>
                        <b-overlay :show="loading">
                            <b-row>
                                <b-col xl="12" lg="12" sm="12">
                                    <ValidationObserver ref="form" v-slot="{ handleSubmit, reset }">
                                        <b-form @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset">
                                            <b-row>
                                                <b-col lg="6" sm="12">
                                                <!-- <ValidationProvider name="Org Approve Attachment" vid="org_approve_attachment" > -->
                                                <ValidationProvider name="Org Approve Attachment" vid="org_approve_attachment" :rules="{required: formData.org_approve_attachment === '' }">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="12"
                                                        label-for="org_approve_attachment"
                                                    >
                                                        <template v-slot:label>
                                                            {{$t('application_management.org_approve_attachment')}}
                                                        </template>
                                                        <b-form-file
                                                        placeholder="Choose a file"
                                                        id="org_approve_attachment"
                                                        v-on:change="onOrgApproveAttachmentChange"
                                                        v-model="formData.org_approve_attachment"
                                                        required
                                                        ></b-form-file>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                              <b-col sm="12">
                                                <office-by-area @send="getOfficeDetails" :col="4" :details="[]" />
                                              </b-col>
                                            </b-row>
                                            <div class="row">
                                                <div class="col-sm-3"></div>
                                                <div class="col text-right">
                                                    <b-button variant="primary" class="mr-2" type="submit"> {{ saveBtnName }}</b-button>
                                                    &nbsp;
                                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-5')">{{ $t('globalTrans.cancel') }}</b-button>
                                                </div>
                                            </div>
                                        </b-form>
                                    </ValidationObserver>
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    // import { mapGetters } from 'vuex'
    import { core } from '@/config/pluginInit'
    import { ValidationObserver, ValidationProvider } from 'vee-validate'
    import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
    import { applicationApply } from '../../api/routes'
    import OfficeByArea from '../../../../../../components/custom/OfficeByAreaExternal'

    export default {
        props: ['id'],
        components: {
            ValidationObserver,
            ValidationProvider,
            OfficeByArea
        },
        created () {
            // if (this.id) {
            //     this.formData.preview = this.items.url
            // }
        },
        mounted () {
            core.index()
        },
        data () {
            return {
                showData: 0,
                is_loading: false,
                saveBtnName: this.$t('externalUser.apply'),
                formData: {
                    id: this.id,
                    org_approve_attachment: '',
                    tempOrg_approve_attachment: ''
                }
            }
        },
        computed: {
            currentLocale () {
                return this.$i18n.locale
            }
        },
        watch: {
        },
        methods: {
            onOrgApproveAttachmentChange (e) {
              // this.upload_image = e.target.files[0]
              const file = e.target.files[0]
              const reader = new FileReader()
              // eslint-disable-next-line no-return-assign
              reader.onloadend = () => this.formData.tempOrg_approve_attachment = reader.result
              reader.readAsDataURL(file)
            },
            async saveData () {
                this.loading = true
                this.$store.dispatch('mutateCommonProperties', { loading: true })
                let result = null
                const loadingState = { loading: false, listReload: false }
                if (this.id) {
                    result = await RestApi.postData(trainingElearningServiceBaseUrl, applicationApply, this.formData)
                }
                loadingState.listReload = true
                this.$store.dispatch('mutateCommonProperties', loadingState)
                if (result.success) {
                    this.loading = false
                    this.$toast.success({
                        title: this.$t('globalTrans.success'),
                        message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                        color: '#D6E09B'
                    })
                    this.$bvModal.hide('modal-5')
                  this.$emit('loadlist', 'someValue')
                }
            },
            getEditData () {
                const tmpData = this.$store.state.list.find(item => item.id === this.id)
                return JSON.parse(JSON.stringify(tmpData))
            },
            getMomoList (fiscalYearId) {
                return this.$store.state.TrainingElearning.commonObj.circularMemoList.filter(item => item.fiscal_year_id === fiscalYearId).map(item => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: item.value, text: item.text_bn }
                    } else {
                        return { value: item.value, text: item.text_en }
                    }
                })
            },
            getPreDistrictList (divisionId = null) {
                const districtList = this.$store.state.commonObj.districtList
                if (divisionId) {
                    return districtList.filter(district => district.division_id === divisionId)
                }
                return districtList
            },
            getPreUpazilaList (districtId = null) {
                const upazilaList = this.$store.state.commonObj.upazilaList
                if (districtId) {
                    return upazilaList.filter(upazila => upazila.district_id === districtId)
                }
                return upazilaList
            },
            getPreCityCorporationList (districtId = null) {
                const cityCorporationList = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
                if (districtId) {
                    return cityCorporationList.filter(upazila => upazila.district_id === districtId)
                }
                return cityCorporationList
            },
            getPauroshobaList (upazillaId = null) {
                const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === upazillaId)
                if (upazillaId) {
                    return objectData.map((obj, key) => {
                        if (this.$i18n.locale === 'bn') {
                            return { value: obj.value, text: obj.text_bn }
                        } else {
                            return { value: obj.value, text: obj.text_en }
                        }
                    })
                }
            },
            getWardListByCityCorportaion (cityCorpId) {
                const objectData = this.$store.state.commonObj.wardList
                const wardObjectList = objectData.filter(item => item.city_corporation_id === cityCorpId && item.status === 0)
                return wardObjectList.map((obj, key) => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: obj.value, text: obj.text_bn }
                    } else {
                        return { value: obj.value, text: obj.text }
                    }
                })
            },
            getPreUnionList (upazilaId = null) {
                const unionList = this.$store.state.commonObj.unionList
                if (upazilaId) {
                    return unionList.filter(union => union.upazilla_id === upazilaId)
                }
                return unionList
            },
            getPerDistrictList (divisionId = null) {
                const districtPerList = this.$store.state.commonObj.districtList
                if (divisionId) {
                    return districtPerList.filter(district => district.division_id === divisionId)
                }
                return districtPerList
            },
            getPerUpazilaList (districtId = null) {
                const upazilaPerList = this.$store.state.commonObj.upazilaList
                if (districtId) {
                    return upazilaPerList.filter(upazila => upazila.district_id === districtId)
                }
                return upazilaPerList
            },
            getPerUnionList (upazilaId = null) {
                const unionPerList = this.$store.state.commonObj.unionList
                if (upazilaId) {
                    return unionPerList.filter(union => union.upazilla_id === upazilaId)
                }
                return unionPerList
            },
            getWardListByPauroshoba (pauroshobaId) {
                const objectData = this.$store.state.commonObj.wardList
                const wardObjectList = objectData.filter(item => item.pauroshoba_id === pauroshobaId && item.status === 0)
                return wardObjectList.map((obj, key) => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: obj.value, text: obj.text_bn }
                    } else {
                        return { value: obj.value, text: obj.text }
                    }
                })
            },
          getOfficeDetails (data) {
            // this.formData = data
            this.formData.office_area_id = data.office_area_id
            this.formData.office_division_id = data.office_division_id
            this.formData.office_district_id = data.office_district_id
            this.formData.office_upazila_id = data.office_upazila_id
            this.formData.office_city_corporation_id = data.office_city_corporation_id
            this.formData.office_paurasabha_id = data.office_paurasabha_id
            this.formData.office_id = data.office_id
          }
        }
    }

</script>
